require('./hspinner.component.scss');

class HSpinnerController {
  constructor(CurrentFilterService) {
    this.limit  = CurrentFilterService.filter && CurrentFilterService.filter.limit || 50;
  }

  get isShowWarinig(){
    return this.limit > 200;
  }
}

export const HSpinnerComponent = {
  template  : require('./hspinner.component.html'),
  bindings  : {
  },
  controller: HSpinnerController,
};



// WEBPACK FOOTER //
// ./src/shared/hspinner.component.js